// extracted by mini-css-extract-plugin
module.exports = {"AppBtn":"AppBtn_AppBtn_3sq9k","AppBtn__Label":"AppBtn_AppBtn__Label_3Aaw2","AppBtn__Loading":"AppBtn_AppBtn__Loading_8XiRV"};